// Dashboard.js
import React, { useState, useEffect } from "react";
import { fetchLicenses } from "../utils/licensesApi";
import { fetchUsers } from "../utils/usersApi";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPowerOff } from "@fortawesome/free-solid-svg-icons";
import { logEmployeeActivity } from "../utils/logsApi";
import { getCurrentUserEmail, getCurrentUserRole, clearAuth } from "../utils/auth";

import SupportBox from "./SupportBox";
import Loading from './Loading';
import LicensesView from "./LicensesView";
import UsersView from "./UsersView";
import TradingViewManager from "./TradingViewManager";
import ContractsView from "./ContractsView";
import AdminPanel from "./AdminPanel";


const Dashboard = () => {
    const [licenses, setLicenses] = useState([]);
    const [users, setUsers] = useState([]);
    const [view, setView] = useState("licenses");
    const [loading, setLoading] = useState(false);
    const [userEmail, setUserEmail] = useState("");
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(true);
    const userRole = getCurrentUserRole();

    const handleLogoutToggle = async () => {
        if (isLoggedIn) {
            const email = getCurrentUserEmail();
            const role = getCurrentUserRole();
            
            // Log employee logout activity
            await logEmployeeActivity(
                "LOGOUT",
                email,
                role,
                "Employee logged out from admin panel"
            );
            
            clearAuth();
            navigate("/");
        }
        setIsLoggedIn(!isLoggedIn);
    };

    useEffect(() => {
        // Get user email from auth utilities
        const email = getCurrentUserEmail();
        if (email) {
            setUserEmail(email);
            // Log dashboard access
            logEmployeeActivity(
                "DASHBOARD_ACCESS",
                email,
                userRole,
                "Employee accessed admin dashboard"
            );
        }
    }, [userRole]);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            if (view === "licenses") {
                const data = await fetchLicenses();
                setLicenses(data);
            } else if (view === "users") {
                const data = await fetchUsers();
                setUsers(data);
            }
            setLoading(false);
        };

        fetchData();
    }, [view]);
    return (
        <div className="dashboard-container">
            <div className="user-email-display">
                Hello, <strong>{userEmail}</strong>
            </div>
            <h1 className="dashboard-title">ADAMO CONTROLLER</h1>
            <div className="button-group">
                <button onClick={() => setView("licenses")}>Licenses</button>
                {userRole > 1 &&

                    <button onClick={() => setView("users")}>Users</button>
                }
                {/* {userRole > 1 && */}
                <button onClick={() => setView("contracts")}>Contracts</button>
                {/* } */}
                <button onClick={() => setView("tradingview")}>TRADINGVIEW</button>
                {userRole === 2 && (
                    <button onClick={() => setView("admin")}>Admin Panel</button>
                )}

                <button
                    className={`logout-button ${isLoggedIn ? "on" : "off"}`}
                    onClick={handleLogoutToggle}
                >
                    <FontAwesomeIcon icon={faPowerOff} />
                </button>
            </div>

            <div className="dashboard-content">
                {loading ? (
                    <Loading message={`Loading ${view}...`} />
                ) : (
                    <>
                        {view === "licenses" && (
                            <LicensesView licenses={licenses} users={users} setLicenses={setLicenses} setView={setView} />
                        )}
                        {view === "users" && (
                            <UsersView users={users} setUsers={setUsers} setView={setView} />
                        )}
                        {view === "contracts" &&
                            <ContractsView />
                        }
                        {view === "tradingview" && (
                            <TradingViewManager />
                        )}
                        {view === "admin" && userRole === 2 && (
                            <AdminPanel />
                        )}
                    </>
                )}
            </div>
            <SupportBox />
        </div>
    );
};

export default Dashboard;
